<div nz-row class="my-account-users">
  <div nz-col nzSpan="22" nzOffset="1" [ngClass]="'p-3'">
    <h1 nz-typography>Abonamente</h1>
    <nz-alert nz-Class nzType="success" *ngIf="successCredit" nzMessage="Creditele au fost adaugate cu success"></nz-alert>
    <nz-alert nz-Class nzType="error" *ngIf="failCredit" nzMessage="Eroare la adaugarea creditului"></nz-alert>
    <nz-spin [nzSpinning]="loading">
      <nz-pagination class="custom-pagination" [(nzPageIndex)]="pageIndex" [nzTotal]="totalPages" [nzPageSizeOptions]="[10, 20, 30, 40, 100]" (nzPageIndexChange)="pageIndexChanged($event)" nzShowSizeChanger [nzPageSize]="pageSize" (nzPageSizeChange)="pageSizeChanged($event)" style="float: right; margin-bottom: 10px"></nz-pagination>
      <nz-table #usersTable nzSize="small" [nzData]="usersToDisplay" [nzFrontPagination]="false" [nzTableLayout]="!isMobile ? 'fixed' : ''" [nzScroll]="isMobile ? { x: '1300px' } : ''">
        <thead>
          <tr>
            <th nzWidth="60px">ID</th>
            <th nzWidth="180px" nzCustomFilter nz-tooltip="Nume si prenume">
              <input nz-input placeholder="NAME" nzBorderless (keyup)="filterBy()" [(ngModel)]="searchValueName" />
            </th>
            <th nzWidth="240px" nzCustomFilter nz-tooltip="După email">
              <input nz-input placeholder="EMAIL" nzBorderless (keyup)="filterBy()" [(ngModel)]="searchValueEmail" />
            </th>
            <th nz-tooltip="Statusul abonamentului">
              <nz-select class="table-selector" ngModel="status" nzBorderless [(ngModel)]="searchStatus"(ngModelChange)="getUsers()">
                <nz-option nzValue="" nzLabel="Status"></nz-option>
                <nz-option nzValue="1" nzLabel="Activ"></nz-option>
                <nz-option nzValue="0" nzLabel="Inactiv"></nz-option>
              </nz-select>
            </th>
            <th nzCustomFilter nz-tooltip="Data abonării">
              <nz-date-picker nzBorderless nzMode="month" [(ngModel)]="searchCreationDate" nzPlaceHolder="ABONARE" (ngModelChange)="filterBy()"></nz-date-picker>
            </th>
            <th nzCustomFilter nz-tooltip="Data ultimei plăţi">
              <nz-date-picker nzBorderless nzMode="month" [(ngModel)]="searchCreationDate" nzPlaceHolder="ULTIMA PLATĂ" (ngModelChange)="filterBy()"></nz-date-picker>
            </th>
            <th nzCustomFilter nz-tooltip="Data următoarei plăţi">
              <nz-date-picker nzBorderless nzMode="month" [(ngModel)]="searchNextPaymentDate" nzPlaceHolder="URMĂTOAREA PLATĂ" (ngModelChange)="filterBy()"></nz-date-picker>
            </th>
            <th nz-tooltip="Tipul de abonament">
              <nz-select class="table-selector" [(ngModel)]="selectedSubscriptionType" nzBorderless (ngModelChange)="filterBySubscriptionType($event)">
                <nz-option nzValue="all" nzLabel="Tip Abonament"></nz-option>
                <nz-option nzValue="1" nzLabel="1 analiză lunară"></nz-option>
                <nz-option nzValue="2" nzLabel="2 analize lunare"></nz-option>
                <nz-option nzValue="3" nzLabel="3 analize lunare"></nz-option>
                <nz-option nzValue="4" nzLabel="nelimitat"></nz-option>
              </nz-select>
            </th>
            <th nz-tooltip="Valoarea abonamentului">
              <nz-select class="table-selector" [(ngModel)]="selectedSubscriptionType" nzBorderless (ngModelChange)="filterBySubscriptionType($event)">
                <nz-option nzValue="all" nzLabel="Valoare Abonament"></nz-option>
                <nz-option nzValue="1" nzLabel="90"></nz-option>
                <nz-option nzValue="2" nzLabel="170"></nz-option>
                <nz-option nzValue="3" nzLabel="240"></nz-option>
                <nz-option nzValue="4" nzLabel="500"></nz-option>
              </nz-select>
            </th>
            <th nzCustomFilter nz-tooltip="Data dezabonării">
              <nz-date-picker nzBorderless nzMode="month" [(ngModel)]="searchCancelDate" nzPlaceHolder="DEZABONARE" (ngModelChange)="filterBy()"></nz-date-picker>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let result of usersTable.data; let i = index">
            <td>{{ result.id }}</td>
            <td>{{ result.userFirstName }} {{ result.userLastName }}</td>
            <td>{{ result.userEmail }}</td>
            <td style="text-align: center">
              <span *ngIf="result.status == 1" style="color: green">Activ</span>
              <span *ngIf="result.status == 0" style="color: red">Inactiv</span>
            </td>
            <td style="text-align: center">
              {{ result.dateCreated | momentDate }}
            </td>
            <td style="text-align: center">
              {{ result.lastPaid | momentDate }}
            </td>
            <td style="text-align: center">
              {{ result.nextPaymentDate | momentDate }}
            </td>
            <ng-container *ngIf="result.subscriptionType == '1'">
              <td>{{ result.subscriptionType }} analiză lunară</td>
              <td style="text-align: center">90</td>
            </ng-container>
            <ng-container *ngIf="result.subscriptionType == '2'">
              <td>{{ result.subscriptionType }} analize lunare</td>
              <td style="text-align: center">170</td>
            </ng-container>
            <ng-container *ngIf="result.subscriptionType == '3'">
              <td>{{ result.subscriptionType }} analize lunare</td>
              <td style="text-align: center">240</td>
            </ng-container>
            <ng-container *ngIf="result.subscriptionType == '4'">
              <td>Nelimitat</td>
              <td style="text-align: center">500</td>
            </ng-container>
            <td style="text-align: center">
              {{ result.cancelPaymentDate | momentDate }}
            </td>
          </tr>
        </tbody>
      </nz-table>
    </nz-spin>
    <nz-pagination class="custom-pagination" [(nzPageIndex)]="pageIndex" [nzTotal]="totalPages" [nzPageSizeOptions]="[10, 20, 30, 40, 100]" (nzPageIndexChange)="pageIndexChanged($event)" nzShowSizeChanger [nzPageSize]="pageSize" (nzPageSizeChange)="pageSizeChanged($event)" style="float: right; margin-top: 10px; margin-bottom: 30px"></nz-pagination>
  </div>
</div>
